export default "__VITE_ASSET__BmgeSmjc__"